import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {NgSpinKitModule} from 'ng-spin-kit';
import {IntroPageComponent} from '@app/platform/intro-page.component';
import {BackgroundComponent} from '@app/shared/background.component';
import {SafeHtmlPipe} from '@app/shared/safe-html.pipe';
import {SiqSpinnerComponent} from '@app/shared/spinner.component';
import {SyncLoaderPageComponent} from '@app/sync/sync-loader-page.component';

@NgModule({
    imports: [
        CommonModule,
        NgSpinKitModule,
    ],
    declarations: [
        BackgroundComponent,
        SafeHtmlPipe,
        SiqSpinnerComponent,
        IntroPageComponent,
        SyncLoaderPageComponent,
    ],
    exports: [
        BackgroundComponent,
        SafeHtmlPipe,
        SiqSpinnerComponent,
        IntroPageComponent,
        SyncLoaderPageComponent,
    ],
})
export class SharedModule {}
